import React from "react";
import { fetcher } from "../services/sagas/fetcher.saga";

import { Redirect, Route } from "react-router-dom";

const urlAuthLocal = "http://localhost:3000/?scope=commande";
const urlAuthDev = "https://auth.laddit.io/?scope=commande";
const urlAuthProd = "https://auth.laddition.com/?scope=commande";

const loggedIn = (refreshToken) => {
  try {
    isLogin(refreshToken);
    return true;
  } catch (e) {
    return false;
  }
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const urlRefreshToken = new URL(window.location.href).searchParams.get("refresh_token");
  if (urlRefreshToken !== window.localStorage.refreshToken) {
    window.localStorage.refreshToken = urlRefreshToken;
  }

  return <Route
    {...rest}
    render={(props) =>
      loggedIn(window.localStorage.refreshToken) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/admin",
            state: { from: props.location },
          }}
        />
      )
    }
  />;
};

export default PrivateRoute;

const isLogin = async (refreshToken) => {
  if (refreshToken && refreshToken !== "null") {
    getAccessToken(refreshToken);
    return true;
  } else {
    if (window.location.hostname === "localhost") {
      whatHostAndGetToken(urlAuthLocal);
      return true;
    }
    if (window.location.hostname === "commande-en-ligne.laddit.io") {
      whatHostAndGetToken(urlAuthDev);
      return true;
    }
    if (window.location.hostname === "commande-en-ligne.laddition.com") {
      whatHostAndGetToken(urlAuthProd);
      return true;
    }
  }
};

// get search path with token and add into localStorage
const whatHostAndGetToken = async (location) => {
  let url = new URL(window.location.href);
  let refreshToken = url.searchParams.get("refreshToken");
  if (refreshToken && refreshToken.length > 0) {
    window.localStorage.setItem("refreshToken", refreshToken);
    window.localStorage.setItem("login", true);
  } else {
    window.location = location;
  }
};

const getAccessToken = async (refreshToken) => {
  try {
    let res = await fetcher("get", `auth/accessToken`, {}, refreshToken);
    if (res && res.data && res.data.success) {
      window.sessionStorage.setItem("accessToken", res.data.accessToken);
    }
    return true;
  } catch (e) {
    return e;
  }
};
